import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { JhiAlertService, JhiDataUtils, JhiEventManager } from 'ng-jhipster';
import { AlertUtils, FileUtils } from '../../../shared';

import * as $ from 'jquery';

@Component({
    selector: 'qms-file-input',
    templateUrl: './file-input.component.html',
    styleUrls: [
        'file-input.component.css'
    ]
})
export class FileInputComponent implements OnInit {
    private static CLEAR_METHOD = 'clear';
    private static REFRESH_METHOD = 'refresh';
    private static CHANGE_EVENT = 'change';
    private static FILE_ERROR_EVENT = 'fileerror';

    // Needed due to concurrency issues in file-input eventing mechanism.
    // Data util converts file to Base64 too late so then we need to know about previous error.
    private wasError: boolean;

    @Input()
    public data: any;

    @Input()
    public contentType: string;

    @Input()
    public id: string;

    @Input()
    public browseButtonTranslation: string;

    @Input()
    public placeholderMessageTranslation: string;

    @Input()
    public noFileSelectedTranslation: string;

    @Input()
    public maxFileSize: number;

    @Input()
    public allowImagesOnly = false;

    @Output()
    public onFileChanged: EventEmitter<any>;

    @Output()
    public onClear: EventEmitter<any>;

    constructor(private translateService: TranslateService,
                private alertService: JhiAlertService,
                private eventManager: JhiEventManager,
                private dataUtils: JhiDataUtils) {

        this.onFileChanged = new EventEmitter();
        this.onClear = new EventEmitter();
        this.wasError = false;
    }

    ngOnInit() {
        const options: any = {
            maxFileSize: this.maxFileSize,
            showPreview: false,
            showUpload: false,
            showRemove: false,
            browseClass: 'btn btn-primary',
            browseIcon: '<i class="fa fa-folder-open"></i>'
        };

        if (this.allowImagesOnly && this.allowImagesOnly === true) {
            options.allowedFileTypes = ['image'];
        }

        const input = $('#file-input-id');
        input.fileinput(options);
        input.on(FileInputComponent.FILE_ERROR_EVENT, () => {
            this.wasError = true;
            this.clearFile();

            AlertUtils.notifyError(this.eventManager, this.alertService, 'error.fileInputError');
            if (this.maxFileSize) {
                AlertUtils.notifyError(this.eventManager, this.alertService, 'error.fileInputMaxSizeError', {
                    max: this.maxFileSize
                });
            }
        });
        input.on(FileInputComponent.CHANGE_EVENT, (event: any) => {
            // Assume there is no error. File error event would override.
            this.wasError = false;
            this.handleChange(event);
        });

        this.updateTranslations();
        this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
            this.updateTranslations();
        });
    }

    public handleChange(event: any) {
        FileUtils.setFileData(event, this.dataUtils, (fileData: any, fileType: string) => {
            if (this.wasError === false) {
                // Assign file content to model only if there was no error
                this.data = fileData;
                this.contentType = fileType;
                this.onFileChanged.emit(event);
            }
        });
    }

    public clearFile() {
        $('#file-input-id').fileinput(FileInputComponent.CLEAR_METHOD);
        this.contentType = null;
        this.data = null;
        this.onClear.emit();
    }

    public getImage(): string | undefined {
        return FileUtils.getImageBase64Format(this.data, this.contentType);
    }

    private updateTranslations() {
        const options: any = {};
        if (this.browseButtonTranslation) {
            options.browseLabel = this.translateService.instant(this.browseButtonTranslation);
        }
        if (this.placeholderMessageTranslation) {
            options.msgPlaceholder = this.translateService.instant(this.placeholderMessageTranslation);
        }
        if (this.noFileSelectedTranslation) {
            options.msgNoFilesSelected = this.translateService.instant(this.noFileSelectedTranslation);
        }

        $('#file-input-id').fileinput(FileInputComponent.REFRESH_METHOD, options);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/generic/file-input/file-input.component.ts